// Adds a just-inserted reference row to the current selection.
// Single-select replaces; multi-select appends unless already present.
export const mergeInsertedReferenceRow = (
  selectedRows: any[],
  row: any,
  dataKey: string,
  multiSelect: boolean | undefined
): any[] => {
  if (!multiSelect) return [row];
  if (selectedRows.some((r) => r[dataKey] === row[dataKey]))
    return selectedRows;
  return [...selectedRows, row];
};
